var app = angular.module('inoApp')

app.factory('headersInjectorInterceptor', function () {
    var headerInjector = {
        request: function (config) {
            config.headers['X-Requested-With'] = "XMLHttpRequest";
            return config;
        }
    };

    return headerInjector;
});

app.config(['$httpProvider', function ($httpProvider) {
    $httpProvider.interceptors.push('headersInjectorInterceptor');
}]);